import { Translation, useSafetyTranslation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button/Button'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'

import styles from './DocumentsTreeSummary.module.scss'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks
interface IProps {
  grouping: 'partner' | 'creator'
  groupCount: number
  documentCount: number
  onExpandAll: () => void
  onCollapseAll: () => void
}
export const DocumentsTreeSummary = ({
  grouping,
  groupCount,
  documentCount,
  onExpandAll,
  onCollapseAll,
}: IProps) => {
  const t = useSafetyTranslation()
  return (
    <div className={styles.summary}>
      <Translation
        span
        text={KEYS.treeDocuments.groupSummary}
        replaceParams={[
          { key: '{groups}', value: String(groupCount) },
          {
            key: '{unit}',
            value: t(
              grouping === 'partner' ? KEYS.treeDocuments.partners : KEYS.treeDocuments.creators
            ),
          },
          {
            key: '{count}',
            value: String(documentCount),
          },
        ]}
      />
      <div className={styles.actions}>
        <Button variant="text" size="sm" onClick={onExpandAll}>
          <Translation span text={KEYS.treeDocuments.expandAll} />
        </Button>
        <Button variant="text" size="sm" onClick={onCollapseAll}>
          <Translation span text={KEYS.treeDocuments.collapseAll} />
        </Button>
      </div>
    </div>
  )
}
